define.alias("ember-cli-string-helpers/helpers/underscore", "calendar/helpers/underscore");